/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPBUSINESSRELATIONTYPE = {
    AuthorisedRepresentativeAUTHR: 'AUTHR',
    ControllingEntityCTRLE: 'CTRLE',
    Manager: 'MANAG',
    ExecutiveOfficial: 'EXEOFF',
    ShareHolder: 'SHAREH',
    Member: 'MEMBER',
    ContactCONTACT: 'CONTACT',
    FounderOrSettlor: 'SET',
    Protector: 'PRT',
    Trustee: 'TRT',
    LeadTrustee: 'LDT',
    AuthorisedRepresentativeAUTR: 'AUTR',
    ControllingEntityCE: 'CE',
    TrustBeneficiary: 'TRUB',
    ContactC: 'C',
    BeneficialOwner: 'BENO',
    NamedBeneficiary: 'NBEN',
    OtherOTH: 'OTH',
    OtherOTHT: 'OTHT'
} as const;
export type IAPBUSINESSRELATIONTYPE = typeof IAPBUSINESSRELATIONTYPE[keyof typeof IAPBUSINESSRELATIONTYPE];


export function IAPBUSINESSRELATIONTYPEFromJSON(json: any): IAPBUSINESSRELATIONTYPE {
    return IAPBUSINESSRELATIONTYPEFromJSONTyped(json, false);
}

export function IAPBUSINESSRELATIONTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPBUSINESSRELATIONTYPE {
    return json as IAPBUSINESSRELATIONTYPE;
}

export function IAPBUSINESSRELATIONTYPEToJSON(value?: IAPBUSINESSRELATIONTYPE | null): any {
    return value as any;
}

